import { render, staticRenderFns } from "./PrevNext.vue?vue&type=template&id=3cdcf864&scoped=true&"
import script from "./PrevNext.vue?vue&type=script&lang=js&"
export * from "./PrevNext.vue?vue&type=script&lang=js&"
import style0 from "./PrevNext.vue?vue&type=style&index=0&id=3cdcf864&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdcf864",
  null
  
)

export default component.exports